<template>
  <div>
    <Navbar />
    <div class="w-section page-header">
      <div
        data-ix="navbar-grow"
        class="page-header-overlay default"
      >
        <div class="w-container container">
          <h1
            data-ix="fade-in-on-load"
            class="w-editable page-header-title"
          >
            Got a project in mind?
          </h1>
          <h1
            data-ix="fade-in-on-load-2"
            class="w-editable page-header-title subtitle"
          >
            Request a quote by using the form below!
          </h1>
        </div>
      </div>
    </div>
    <div class="w-section section">
      <div class="w-container container info-container">
        <div class="w-form quote-form">
          <form
            id="wf-form-Request-a-quote"
            name="wf-form-Request-a-quote"
            data-name="Request a quote"
            :submit="submit"
            action="#"
            method="post"
          >
            <div class="w-clearfix quote-section-wrapper">
              <div
                data-ix="fade-in-on-scroll"
                class="info-image-block quote-1"
              />
              <div
                data-ix="fade-in-on-scroll-2"
                class="info-text-block quote-block-1"
              >
                <div class="w-editable intro-block-title">
                  <span class="block-title-color">
                    1.
                  </span>
                  Personal information
                </div>
                <p class="w-editable">
                  Please fill in your personal information.
                  Lorem ipsum dolor sit amet, consectetur adipiscing elite.
                </p>
                <input
                  id="Name-8"
                  type="text"
                  placeholder="Enter your name"
                  name="Name"
                  data-name="Name"
                  required="required"
                  class="w-input field first"
                >
                <input
                  id="Email-Address-8"
                  type="email"
                  placeholder="Email address"
                  name="Email-Address"
                  data-name="Email Address"
                  required="required"
                  class="w-input field"
                >
                <input
                  id="Phone-number-7"
                  type="text"
                  placeholder="Phone number"
                  name="Phone-number"
                  data-name="Phone number"
                  required="required"
                  class="w-input field"
                >
                <input
                  id="Location"
                  type="text"
                  placeholder="Location"
                  name="Location"
                  data-name="Location"
                  class="w-input field"
                >
              </div>
            </div>
            <div class="w-clearfix quote-section-wrapper last">
              <div
                data-ix="fade-in-on-scroll-2"
                class="info-image-block quote-2"
              />
              <div
                data-ix="fade-in-on-scroll"
                class="info-text-block quote-block-2"
              >
                <div class="w-editable intro-block-title">
                  <span class="block-title-color">
                    2.
                  </span>
                  Project information
                </div>
                <p>
                  Describe your project. Lorem ipsum dolor sit amet,
                  consectetur adipiscing elite lorem ipsum.
                </p>
                <input
                  id="Name-9"
                  type="text"
                  placeholder="Name of project"
                  name="Name"
                  data-name="Name"
                  class="w-input field first"
                >
                <select
                  id="Services"
                  name="Services"
                  data-name="Services"
                  required="required"
                  multiple="multiple"
                  class="w-select field"
                >
                  <option value="">
                    Needed services...
                  </option>
                  <option value="Graphic Design">
                    Graphic Design
                  </option>
                  <option value="Webdesign">
                    Webdesign
                  </option>
                  <option value="Illustration">
                    Illustration
                  </option>
                  <option value="Photography">
                    Photography
                  </option>
                  <option value="UIX Design">
                    UIX Design
                  </option>
                </select>
                <textarea
                  id="Project-description"
                  placeholder="Project description"
                  name="Project-description"
                  data-name="Project description"
                  required="required"
                  class="w-input field area project-description"
                />
                <input
                  type="submit"
                  value="Request a quote"
                  data-wait="Please wait..."
                  class="w-button button">
              </div>
            </div>
          </form>
          <div class="w-form-done success-bg dark">
            <p>Thank you! We will get back to you within 1 or 2 days.</p>
          </div>
          <div class="w-form-fail error-bg">
            <p class="error-text">
Oops! Something went wrong while submitting the form
</p>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/TheNavbar'
import Footer from '@/components/TheFooter'

export default {
  components: {
    Navbar,
    Footer,
  },

  mounted() {
    // eslint-disable-next-line
    $(Webflow.destroy)
    setTimeout(() => {
      // eslint-disable-next-line
      $(Webflow.ready)
    }, 1)
  },

  destroyed() {
    // eslint-disable-next-line
    $(Webflow.destroy)
  },

  methods: {
    submit() {
      // handle form submit
    },
  },
}
</script>
